<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title60"></a>
<div class="p-c-br"><span><em class="i">To my mother, Louise Bryden Buck, M.D.,</em> <br/><em class="i">for patient love and lessons in healing</em></span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429949880_ded01.vue?0d11f6b6